// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__E6x8l","cell":"ColumnAccessor_cell__3Q8cz","firstCellAccent":"ColumnAccessor_firstCellAccent__2Y7ni"};